/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const bulkDraftChallengesBodySchema = z.object({
  titles: z.array(z.string().min(1)).min(1).max(100),
  collectionId: z.number().int().positive().optional(),
});

export type IBulkDraftChallengesBody = z.infer<typeof bulkDraftChallengesBodySchema>;
